import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setUnSavedChangesData } from 'reducers/homeReducer'
import { useLocation } from 'react-router-dom'

const usePreventUnsavedChanges = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const { unSavedChangesData: changesData } = useSelector((state) => state.homeReducer)
    const [previousUrls, setPreviousUrls] = useState([])

    useEffect(() => {
        if (previousUrls.length > 1) {
            dispatch(setUnSavedChangesData({ urlNavigate: previousUrls[0] }))
            setPreviousUrls([previousUrls[1], location.pathname])
        } else {
            setPreviousUrls([...previousUrls, location.pathname])
        }
    }, [location])

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (changesData?.isFilledForm) {
                event.preventDefault()
                event.returnValue = ''
            }
        }

        const handleBackButton = (event) => {
            if (changesData?.isFilledForm) {
                event.preventDefault()
                dispatch(setUnSavedChangesData({ isShowConfirm: true }))
            }
        }

        window.history.pushState(null, '', location.href)
        window.addEventListener('beforeunload', handleBeforeUnload)
        window.addEventListener('popstate', handleBackButton)

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
            window.removeEventListener('popstate', handleBackButton)
        }
    }, [changesData?.isFilledForm])

    useEffect(() => {
        if (changesData?.isFilledForm && changesData?.isClickAnotherPage) {
            dispatch(setUnSavedChangesData({ isShowConfirm: true }))
        }
    }, [changesData?.isClickAnotherPage])
}

export default usePreventUnsavedChanges
